import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { loginService } from '../../service/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';

@Component({
  selector: 'app-setnewpassword',
  templateUrl: './setnewpassword.component.html',
  styleUrls: ['./setnewpassword.component.css'],
  providers:[loginService]
})
export class SetnewpasswordComponent implements OnInit {
  SETPassword={'title':'Reset New Password','desciprtion':'desciprtion'};
  isLoginError=false;
  issuccess=false;
  isresetform=false;
  msg:any;
  token:string;
  path:any;
  constructor(private global: Globals,private route: ActivatedRoute,public router: Router,private _login:loginService) {
    this.path=this.global.siteUrl+this.global.profileFolder+'/';
   }

  ngOnInit() {
    this.checktokenisvalid();
    
  }

  checktokenisvalid(){

    this.route.queryParams.subscribe(params => {
      this.token=params['token'];
      if(params['token']!="" && params['token']!=undefined){

        this._login.tokenAuthentication(params['token']).subscribe((data : any)=>{
          if(data.error==0){ 
            this.isresetform=true;                  
            //console.log("success");         
          }else{
            localStorage.setItem('_msg',data.message);
            this.router.navigate(['/']);
          }
     },
     (error : HttpErrorResponse)=>{
       this.isLoginError = true;
       this.msg="internal server error!";
     });
      
      }else{
        this.router.navigate(['/']);
       // this.isLoginError=true;
       // this.msg="Your password reset token has expired.";
       
      }
     

    })

  }

  onresetin(passwordtxt,cpasswordtxt){

   if(passwordtxt!="" &&  cpasswordtxt!="") {
    if(passwordtxt!=cpasswordtxt){
       this.isLoginError=true;
       this.msg="Password does not match the confirm password!";
    }else{

            this._login.resetAuthentication(passwordtxt,this.token).subscribe((data : any)=>{
              if(data.error==0){ 
                this.isresetform=false;
                this.isLoginError = false;
                this.issuccess=true;
                this.msg=data.message;                 
                localStorage.setItem('msg',data.message);
                //this.router.navigate(['/']);
              }else{
                this.router.navigate(['/']);
              }
          },
          (error : HttpErrorResponse)=>{
            this.issuccess=false;
            this.isLoginError = true;
            this.msg="internal server error!";
          });
    } 

  }
  else{
    this.isLoginError=true;
        this.msg="Please fill required fields";
  }

   
 }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/setnewpassword/setnewpassword.component.ts